import styled from 'styled-components';

interface PietroskiFormProps {
    darkMode?: boolean;
    width?: string;
    minHeight?: string;
    margin?: string;
    titleFontSize?: string;
}

export const PietroskiFormBox = styled.div`
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;

    background-color: ${(props: PietroskiFormProps) => props.darkMode ? "#282828" : "whitesmoke"};
    color: ${(props: PietroskiFormProps) => props.darkMode ? "whitesmoke" : "black"};
    box-shadow: 0 0 5px 5px ${(props: PietroskiFormProps) => props.darkMode ? "rgba(84, 84, 84, 1)" : "rgba(0, 0, 0, 0.2)"};
    border-radius: 15px;
    border: 1px solid ${(props: PietroskiFormProps) => props.darkMode ? "whitesmoke" : "black"};;
    width: ${(props: PietroskiFormProps) => props.width ? `${props.width}` : "450px"};
    min-height: ${(props: PietroskiFormProps) => props.minHeight ? `${props.minHeight}` : "750px"};
    margin: ${(props: PietroskiFormProps) => props.margin ? `${props.margin}` : "0"};

    h1{
        font-size: ${(props: PietroskiFormProps) => props.titleFontSize ? `${props.titleFontSize}` : "4rem"};
    }
`;